import React, { useState } from "react";
 import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner, Input, Textarea} from "@nextui-org/react";
 import { loginUri, products_uri } from "../../utils/url";
 import { POST } from "../../utils/requests";
 import { toast } from "react-toastify";
 import { PRICE_TYPE } from "../../utils/types";
 import { Checkbox } from "antd";
 
 export default function NotificationAdd() {
   const {isOpen, onOpen, onOpenChange} = useDisclosure();
   const [load, setLoad] = useState(false);
   const [data, setData] = useState({title:'', desc:''});
 
   const Cancel = () => {
     onOpenChange(false);
   };
 
   const Submit = async () => {
     setLoad(true);
     const b = await POST({uri:loginUri +'/notif/all', data: data});
     toast.success("Амжилттай илгээлээ");
     setData({...data, title: "", desc: ""});
     setLoad(false);
     Cancel();
   };
 
   return (
     <>
       <Button size="sm" className="bg-gray-600 text-white" onPress={onOpen}>Мэдэгдэл илгээх</Button>
       <Modal isOpen={isOpen} onOpenChange={onOpenChange} scrollBehavior='inside' size="2xl">
         <ModalContent>
           {(onClose) => (
             <>
               <ModalHeader className="flex flex-col gap-1">Бүх хэрэглэгчидрүү мэдэгдэл илгээх</ModalHeader>
               <ModalBody>
                 <div className="h-4/3">
                   <h1 className="font-Roboto text-sm font-bold">Мэдэгдэлийн гарчиг</h1>
                   <Input size="sm" className="mt-1" placeholder="🤩 Амрах мэдээлэл 🤩"  onChange={(e)=> setData({...data, title: e.target.value})}/>
                   <>
                     <h1 className="font-Roboto text-sm font-bold mt-4">Дэлгэрэнгүй мэдээлэл</h1>
                     <Textarea type="text" size="sm" className="mt-1" placeholder="2024-10-10 нд амарна" onChange={(e)=> setData({...data, desc: e.target.value})}/>
                   </>
                 </div>
               </ModalBody>
               <ModalFooter>
                 <Button color="danger" variant="light" onPress={Cancel}>
                   Болих
                 </Button>
                 {
                   load?
                   <Button color="primary">
                     Уншиж байна ... <Spinner/>
                   </Button>
                   :
                   <Button color="primary" onPress={Submit}>
                     Илгээх
                   </Button>
                 }
               </ModalFooter>
             </>
           )}
         </ModalContent>
       </Modal>
     </>
   );
 }